import TheCalculator from "./TheCalculator";

export default function App() {
  return <TheCalculator />;
}
